import type { WebWidgetModel } from '@web/types';
import type { CodeWidgetData } from '@web/widgets/code/type';

import { Widgets } from '@common/enums';
import { defaultWidgetParams, defaultWidgetPermission } from '@common/constants';

import { CodeViewComponent } from '@web/widgets/code/components/code-view/code-view.component';
import { CodeControlComponent } from '@web/widgets/code/components/code-control/code-control.component';

// DEFAULT COMPONENT SETTINGS
const codeData: CodeWidgetData = {
    content: null,
};
// END DEFAULT SETTINGS

export const codeWidgetModel: WebWidgetModel = {
    componentView: CodeViewComponent,
    componentControl: CodeControlComponent,
    name: Widgets.CODE,
    label: 'widget_code_label',
    data: codeData,
    permission: defaultWidgetPermission,
    params: { ...defaultWidgetParams, hasSetting: false, showControls: false },
};
